import { useSelector } from "react-redux";
import { Button } from "../../../components/button/button";
import { Rewards } from "../../../components/rewards/rewards";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { profileButtons } from "./profileButtons";
import { TelegramIcon } from "../../../assets/icons";
import { openExternalLink } from "../../../utils/openExternalLink";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { clearAuthSession } from "../../../utils/authStorage";
import { Spring } from "../../../components/spring/spring";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { Link } from "react-router";
import { EditableUserInfo } from "../../../components/editableUserInfo/editableUserInfo";

import styles from "./profilePage.module.css";

export const ProfilePage = () => {
    const openPage = useOpenPage();
    const isAdmin = useSelector(state => state.status.isAdmin);
    const isSuperAdmin = useSelector(state => state.status.isSuperAdmin);

    const cafeId = useSelector(state => state.user.userData?.cafeId);

    const supportContact = process.env.REACT_APP_SUPER_ADMIN_NAME || "";
    const supportUrl = /^https?:\/\//i.test(supportContact)
        ? supportContact
        : `https://t.me/${supportContact.replace(/^@/, "")}`;

    const navigate = useAnimatedNavigate();
    const handleLogout = () => {
        clearAuthSession();
        navigate("/auth/login");
    }

    const [Popup, open] = useConfirmPopup(
        "Вы уверены, что хотите выйти?",
        "Все несохраненные данные будут потеряны",
        handleLogout
    );

    return (
        <>
            <EditableUserInfo />

            <Rewards />

            <div className={styles.profile_buttons}>
                {
                    profileButtons
                        .filter(data =>
                            (data.onlyAdmin && isAdmin) ? true :
                                (data.onlySuperAdmin && isSuperAdmin) ? true :
                                    (data.requireCafe && cafeId) ? true :
                                        (!data.onlyAdmin && !data.onlySuperAdmin && !data.requireCafe)
                        ).map((data, i) =>
                            <Button
                                key={i}
                                text={data.text}
                                type={data.type}
                                icon={data.icon}
                                onClick={openPage(data.path)}
                            />
                        )
                }

                <Button
                    type="info"
                    icon={<TelegramIcon />}
                    text="Подать заявку на пользование"
                    onClick={() => openExternalLink(supportUrl)}
                />
            </div>

            <Spring />

            <Button 
                text="Выйти"
                type="semi_destructive"
                onClick={open}
            />

            <Link to="documents" className={styles.documents} viewTransition>Пользовательское соглашение и политика конфиденциальности</Link>

            {Popup}
        </>
    )
}
